import dayjs from 'src/Helpers/dayjs'
import { CampaignStatusEnum } from 'src/Types/campaigns'

export type CampaignMessageType =
  | 'noReviewsNoPlacements'
  | 'hasReviewsNoPlacements'
  | 'hasPlacements'
  | null

interface CampaignDetails {
  id?: number
  start_date?: string | null
  playlists_adds?: number
  status?: CampaignStatusEnum
  isPreRelease?: boolean
}

export const FORTH_DAY = 3

const isEligibleForMessages = (
  status: CampaignStatusEnum | undefined,
  isPreRelease?: boolean,
  playlistsAdds?: number,
): boolean =>
  status === CampaignStatusEnum.RUNNING ||
  (Boolean(isPreRelease) &&
    status === CampaignStatusEnum.ENDED &&
    Boolean(playlistsAdds))

export const useCampaignMessageType = (
  campaignDetails?: CampaignDetails,
  closedIds?: number[],
  reviewsNumber?: number,
  isTrackLinkBlockVisible?: boolean,
): CampaignMessageType => {
  if (!campaignDetails || isTrackLinkBlockVisible) {
    return null
  }

  if (
    !isEligibleForMessages(
      campaignDetails.status,
      campaignDetails.isPreRelease,
      campaignDetails.playlists_adds,
    )
  ) {
    return null
  }

  const isAfterThreshold =
    dayjs().diff(dayjs(campaignDetails.start_date), 'day') >= FORTH_DAY
  const isClosed =
    Array.isArray(closedIds) && closedIds.includes(campaignDetails.id || 0)
  const hasReviews = Boolean(reviewsNumber)
  const hasPlacements = Boolean(campaignDetails.playlists_adds)

  if (isClosed) {
    return null
  }

  if (hasPlacements) {
    return 'hasPlacements'
  }

  if (!isAfterThreshold) {
    return null
  }

  if (!hasReviews) {
    return 'noReviewsNoPlacements'
  }

  return 'hasReviewsNoPlacements'
}
